import { useAppSelector } from 'reduxTyped'
import {
  getIsWhatsAppBusinessAgentEnabled,
  hasConnectedWhatsAppChannel,
} from 'common/core/selectors/channelSelectors'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'
import { useAccountReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'

export const useIsBusinessAgentEnabled = (): boolean | null => {
  const hasWhatsApp = useAppSelector(hasConnectedWhatsAppChannel)
  const isAgentEnabled = useAppSelector(getIsWhatsAppBusinessAgentEnabled)

  const isMbaEnabled = useAccountReleaseToggle(AccountFlag.ENABLE_WA_MBA_SETTINGS)

  const isApplicable = isMbaEnabled && hasWhatsApp

  return isApplicable ? isAgentEnabled : null
}
